import { Component, EventEmitter, OnInit } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-subscription-history-modal',
  templateUrl: './subscription-history-modal.component.html',
  styleUrls: ['./subscription-history-modal.component.scss']
})
export class SubscriptionHistoryModalComponent implements OnInit {

  public subscriptionHistory: string;
  public event = new EventEmitter<string>();
  public startingValue: string;
  displayErrorInSubscriptionHistory: boolean = false;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.subscriptionHistory = this.subscriptionHistory == null ? '' : this.subscriptionHistory;
    this.startingValue = this.subscriptionHistory;
  }
  
  handleModalHide(): void {
    this.bsModalRef.hide();
  }

  onContinueEvent(): void{
     this.event.emit(this.subscriptionHistory);
  }

  isSubmitDisabled(): boolean {
    if (this.startingValue == this.subscriptionHistory) 
    {
      return true;
    }
    else if (this.subscriptionHistory == '') 
    {
      return false;
    }
    else if (this.containsOnlyWhiteSpace(this.subscriptionHistory)) 
    {
      return true;
    }
  }
  containsOnlyWhiteSpace(str: string): boolean {
    return (str || '').trim().length ? false : true;
  }
 
  preventWhiteSpace(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if(inputValue == ' ')
    {
      this.subscriptionHistory ='';
    }
  }
    PreventWhiteSpaceAndNotifyWhenExceedMaxChars(event: KeyboardEvent): void {
    const cursorIndex: number = (event.target as HTMLInputElement).selectionStart;
    this.displayErrorInSubscriptionHistory = false;
    const isAlphabetic = /^[a-zA-Z0-9\u0600-\u06FF\u0660-\u0669\u0670-\u06D3\u06D5\u06E5\u06E6!@#$%^&*()-_=+[\]{}|;:'",.<>/?\\`~\s]$/.test(event.key);

    const shortCuts= event.ctrlKey && (['a','c','x','z','v'].includes(event.key));

    if (event.key == ' ' && (this.subscriptionHistory == '' || this.subscriptionHistory == null 
    || cursorIndex == 0)) 
    {
      event.preventDefault();
    } 

    else if (this.subscriptionHistory != null && this.subscriptionHistory.length >= 50 
      && isAlphabetic && !shortCuts ) 
    {
      event.preventDefault();
      this.displayErrorInSubscriptionHistory = true;
    } 

  }
}
